import { PromiseFactory, } from 'modules/application/misc/PromiseFactory';
import * as styles from './externalPlugin.module.scss';
import { ExternalPluginFeatures } from './ExternalPluginFeatures';
import { applicationListStateName } from 'modules/application/list';
import moment from 'moment';
import { blipStoreStateExtensionsManage } from 'modules/blipStore';
const pluginLoadTracking = 'plugin-loaded';
const MARKETPLACE_PLUGIN_URL = 'https://take-plugin-marketplace.cs.blip.ai';
const BLIPSTORE_PLUGIN_URL = `${window.location.origin}/blip-store/extensions`;
const MSG_DOMAIN = '@msging.net';
export const MARKETPLACE_PLUGIN_ID = 'fixed-marketplace-plugin';
export class ExternalPluginController {
    static $inject = ['$stateParams', '$scope', '$location', '$sce', 'LoadingService', 'SegmentService', 'AccountService2', 'CurrentApplicationService', 'ExternalPluginService', '$state', 'BlipToastService', '$translate'];
    constructor($stateParams, $scope, $location, $sce, LoadingService, SegmentService, AccountService2, CurrentApplicationService, ExternalPluginService, $state, BlipToastService, $translate) {
        'ngInject';
        this.$stateParams = $stateParams;
        this.$scope = $scope;
        this.$location = $location;
        this.$sce = $sce;
        this.LoadingService = LoadingService;
        this.SegmentService = SegmentService;
        this.AccountService2 = AccountService2;
        this.CurrentApplicationService = CurrentApplicationService;
        this.ExternalPluginService = ExternalPluginService;
        this.$state = $state;
        this.BlipToastService = BlipToastService;
        this.$translate = $translate;
        this.isLoading = true;
        this.pluginId = $stateParams.pluginId;
        this.pluginLoad = PromiseFactory.new({ shouldTrackTime: true });
        this.$onInit();
    }
    async $onInit() {
        await this.checkFeatures();
        this.styles = styles;
        if (!this.isPluginEnabled) {
            this.$state.go(applicationListStateName);
        }
        try {
            this.account = await this.AccountService2.me();
            this.userAcceptedTerm =
                this.account.extras.acceptedPlugins &&
                    JSON.parse(this.account.extras.acceptedPlugins).find(({ pluginId }) => {
                        return pluginId && (pluginId == this.pluginId);
                    });
            if (this.userAcceptedTerm) {
                await this.initializePlugin();
            }
        }
        catch (e) {
            console.error(e);
            const errorTitle = await this.$translate('plugin.errorLoadPlugin');
            const errorDescription = await this.$translate('plugin.errorLoadPluginDescription');
            this.BlipToastService.show('danger', {
                title: errorTitle,
                msg: errorDescription,
            });
        }
        finally {
            await this.createTrack(pluginLoadTracking, this.pluginLoad.status, this.pluginLoad.msTime);
            this.isLoading = false;
        }
        this.$scope.$on('$destroy', this.LoadingService.stopLoading);
    }
    async initializePlugin() {
        /**
         * Enable marketplace plugin
         */
        if (this.isMarketplacePluginEnabled && this.pluginId == MARKETPLACE_PLUGIN_ID) {
            this.frameUrl = this.buildPluginUrl(MARKETPLACE_PLUGIN_URL);
            await this.pluginLoad.promise;
            return;
        }
        const plugin = await this.ExternalPluginService.getPlugin(this.pluginId, this.isConfigurationsApplicationsDomainUsageGetEnabled);
        const application = await this.CurrentApplicationService.fetchApplication();
        const pluginPermissions = this.isPluginPermissionsEnabled ? await this.ExternalPluginService.getPluginPermissions(`${application.shortName}${MSG_DOMAIN}`, this.pluginId, this.account.culture) : [];
        this.showBannerPermissions = plugin && pluginPermissions.length > 0;
        this.pluginName = plugin.name;
        this.pluginPermissionUrl = `${BLIPSTORE_PLUGIN_URL}/${this.pluginId}?showPermissionScopes`;
        this.frameUrl = this.buildPluginUrl(plugin.url);
        await this.pluginLoad.promise;
    }
    async checkFeatures() {
        this.isPluginEnabled = await ExternalPluginFeatures.isPluginEnabled();
        this.isMarketplacePluginEnabled = await ExternalPluginFeatures.isMarketplacePluginEnabled();
        this.isConfigurationsApplicationsDomainUsageGetEnabled = await ExternalPluginFeatures.isUseConfigurationsDomainOnMiscOperationsGetEnabled();
        this.isConfigurationsApplicationsDomainUsageSetEnabled = await ExternalPluginFeatures.isUseConfigurationsDomainOnMiscOperationsSetEnabled();
        this.isPluginPermissionsEnabled = await ExternalPluginFeatures.isPluginPermissionsEnabled();
    }
    onFrontendLoad() {
        this.pluginLoad.resolve();
    }
    onFrontendError() {
        this.pluginLoad.reject();
    }
    async acceptTerms() {
        this.userAcceptedTerm = true;
        const acceptedPluginItem = {
            pluginId: this.pluginId,
            acceptedDate: moment(new Date()),
        };
        const acceptedPlugins = this.account.extras.acceptedPlugins
            ? JSON.parse(this.account.extras.acceptedPlugins).concat(acceptedPluginItem)
            : [acceptedPluginItem];
        await this.AccountService2.setExtras({
            acceptedPlugins: JSON.stringify(acceptedPlugins),
        }, false);
        await this.initializePlugin();
    }
    async openBlipStore() {
        this.$state.go(blipStoreStateExtensionsManage);
    }
    buildPluginUrl(pluginUrl) {
        const params = this.$stateParams.path || '';
        let queryString = this.$location.url().split('?')[1];
        queryString = queryString ? `?${queryString}` : '';
        return this.$sce.trustAsResourceUrl(`${pluginUrl}${params}${queryString}`);
    }
    async createTrack(tracking, status, loadTime) {
        const application = await this.CurrentApplicationService.fetchApplication();
        this.SegmentService.createTrack(tracking, {
            pluginId: this.pluginId,
            status,
            botName: application.name,
            botIdentifier: application.shortName,
            timeToLoad: loadTime,
        });
    }
}
ExternalPluginController.$inject = ['$stateParams', '$scope', '$location', '$sce', 'LoadingService', 'SegmentService', 'AccountService2', 'CurrentApplicationService', 'ExternalPluginService', '$state', 'BlipToastService', '$translate'];
